export const styles = {
    buttonSubmit: {
        margin: 1,
    },
    formControl: {
        width: '100%',
        backgroundColor: 'white',
    },
    labelInput: {
        fontFamily: 'Rawline',
        color: '#333333',
        fontWeight: 'bold',
        paddingLeft: 2,
        fontSize: 14,
        marginBottom: '0.5rem'
    },
};